import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGift, FiDownload, FiMessageCircle, FiArrowRight, FiX } = FiIcons;

const ExitPreventionSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section className="py-20 px-4 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-yellow-900/10 to-slate-900/50"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto">
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              🚧 <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">เดี๋ยวก่อน!</span> ถ้ายังไม่พร้อมสมัคร...
            </h2>
            
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
              อย่าเพิ่งปิดหน้านี้แล้วกลับไปเสี่ยงกับการเดาใจคน
            </p>
          </motion.div>

          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-slate-800/50 backdrop-blur-sm border border-yellow-500/30 rounded-2xl p-8"
            >
              <div className="text-center mb-8">
                <SafeIcon icon={FiGift} className="text-6xl text-yellow-400 mx-auto mb-4" />
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                  ผมมี <span className="text-yellow-400">"E-Book: 5 สัญญาณเตือนภัยในโหงวเฮ้งและปาจื้อ"</span> (ฉบับย่อ)
                </h3>
                <p className="text-lg text-gray-300">
                  แจกให้ไปลองสังเกตคนรอบตัวดูก่อน <span className="text-yellow-400 font-semibold">ฟรี!</span>
                </p>
              </div>

              <div className="bg-slate-700/50 rounded-xl p-6 mb-8">
                <h4 className="text-xl font-bold text-white mb-4">กติกา:</h4>
                <div className="space-y-3 text-gray-300">
                  <div className="flex items-center">
                    <span className="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    <p>แอดไลน์ @fengshuix</p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    <p>พิมพ์ "รับ E-Book อ่านคน"</p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    <p>รับลิงก์ได้เลย</p>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <button 
                  onClick={() => setShowModal(true)}
                  className="group relative px-8 py-4 bg-gradient-to-r from-yellow-500 to-orange-600 text-white font-bold text-lg rounded-full shadow-2xl hover:shadow-yellow-500/25 transition-all duration-300 transform hover:scale-105 border border-yellow-400/50"
                >
                  <span className="flex items-center space-x-2">
                    <SafeIcon icon={FiDownload} className="text-xl" />
                    <span>แอดไลน์รับของฟรี</span>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-yellow-600 to-orange-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
                </button>
              </div>
            </motion.div>

            {/* Author Note */}
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              className="mt-12 text-center"
            >
              <div className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 max-w-3xl mx-auto">
                <h4 className="text-xl font-bold text-white mb-4">หมายเหตุจาก อ.รวิ:</h4>
                <p className="text-gray-300 leading-relaxed">
                  ผมปรับเนื้อหาให้มีความเป็น <span className="text-blue-400 font-semibold">"Business Psychology"</span> ผสมกับ <span className="text-purple-400 font-semibold">"Metaphysics"</span> เพื่อให้ดูทันสมัย และเข้าถึงง่ายสำหรับคนทำงานและนักธุรกิจ ไม่ใช่แค่เรื่องความรักหนุ่มสาว
                </p>
                <p className="text-gray-300 mt-4">
                  และ Story ของคุณในส่วน Social Proof คือ <span className="text-green-400 font-semibold">"Killer Content"</span> ที่ดีมากครับ เพราะมันพิสูจน์ว่าวิชานี้คือ <span className="text-yellow-400 font-semibold">"Risk Management"</span> (การบริหารความเสี่ยง) อย่างแท้จริง
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setShowModal(false)}></div>
          
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative bg-slate-800 border border-slate-700 rounded-2xl p-8 max-w-md w-full"
          >
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            >
              <SafeIcon icon={FiX} className="text-xl" />
            </button>
            
            <div className="text-center">
              <SafeIcon icon={FiMessageCircle} className="text-4xl text-green-400 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-white mb-4">แอดไลน์เพื่อรับ E-Book ฟรี</h3>
              
              <div className="bg-slate-700/50 rounded-xl p-4 mb-6">
                <p className="text-lg font-bold text-green-400 mb-2">@fengshuix</p>
                <p className="text-gray-300 text-sm">พิมพ์: "รับ E-Book อ่านคน"</p>
              </div>
              
              <button
                onClick={() => {
                  window.open('https://line.me/R/ti/p/@fengshuix', '_blank');
                  setShowModal(false);
                }}
                className="w-full px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <span>เปิด LINE</span>
                <SafeIcon icon={FiArrowRight} className="text-lg" />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

export default ExitPreventionSection;